/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/11
 * Time: 9:51
 * Desc: 试穿报表
 */

import { Component, Vue } from 'vue-property-decorator';
import { IPSService } from '@/services/ipsServices';
import NoAuth from '@/views/components/noAuth/noAuth.vue';

@Component({
  components: {
    NoAuth,
  },
})
export default class TryOnBoard extends Vue {
  /* 数据 */

  /**
   * loading状态
   * @type {boolean}
   */
  public loadingState = false;

  /**
   * 试穿列表
   * @type {Array<tryOnItem>}
   */
  public tryOnList: Array<tryOnItem> = [];

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 10;

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  /**
   * 是否选中活动
   * @type {boolean}
   */
  public isSelected = false;

  /**
   * 关键字
   * @type {string}
   */
  public keywords = '';

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = false;

  /* 方法 */
  /**
   * 条数变更
   * @ {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.getTryOnList();
  }

  /**
   * 页码变更
   * @ {number} val
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;
    this.getTryOnList();
  }

  /**
   * 关键字搜索
   * @return null
   */
  public onSearchTryOn(): void {
    this.page = 1;
    this.pageSize = 10;
    this.getTryOnList();
  }

  /**
   * 选中的活动
   * @param val
   * @return null
   */
  public onHandleSelectionChange(val): void {
    this.isSelected = val.length > 0;
  }

  /**
   * 去往网点试穿页面
   * @param {number} siteId
   * @param {string} siteName
   * @return null
   */
  public onGoToSiteTryOn(siteId: number, siteName: string): void {
    this.$router.push(`/tryOnBoard/site/${siteId}`);
    this.$store.commit('onModifySiteName', siteName);
  }

  /**
   * 获取试穿列表
   * @return null
   */
  public getTryOnList(): void {
    const queryParams = {
      page: this.page,
      pageNum: this.pageSize,
      keywords: this.keywords,
    };
    IPSService.siteTryOnNum({ queryParams })
      .then((res) => {
        this.tryOnList = res.list;
        this.totalCount = res.count;
      })
      .catch((err) => {
        throw err;
      });
  }
  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-REPORT-TRYON');
    if (this.isContentBodyShow) {
      this.getTryOnList(); // 获取试穿列表
    }
  }
}
